"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FiTarget, FiChevronDown, FiCheck, FiSearch, FiX } from "react-icons/fi";
import * as Select from "@radix-ui/react-select";
import { useIndicationsQuery } from "@/reactQuery/indication";
const IndicationSelection = t0 => {
  const $ = _c(48);
  const {
    selectedIndication,
    setSelectedIndication,
    onBack,
    onNext,
    productID
  } = t0;
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const {
    data,
    isLoading,
    isError
  } = useIndicationsQuery(productID);
  let t1;
  if ($[0] !== data || $[1] !== searchQuery) {
    const allIndications = data?.indicationsList?.length > 0 ? [...data.indicationsList, "Other"] : ["Other"];
    t1 = allIndications.filter(indication => indication.toLowerCase().includes(searchQuery.toLowerCase()));
    $[0] = data;
    $[1] = searchQuery;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const filteredIndications = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><FiTarget className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Select Indication</h2></div>;
    t3 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">Which indication are you rating this product for today?</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <label className="block text-xs sm:text-sm font-semibold text-gray-900 font-poppins mb-2">Select Indication <span className="text-red-500">*</span></label>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = open => {
      setIsOpen(open);
      if (!open) {
        setSearchQuery("");
      }
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== setSelectedIndication) {
    t6 = value => {
      setSelectedIndication(value);
      setSearchQuery("");
    };
    $[7] = setSelectedIndication;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Select.Value placeholder="Choose an indication..." className="text-gray-900" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Select.Trigger className="w-full flex items-center justify-between rounded-lg border-2 border-gray-200 focus:border-primary-primaryBlue focus:outline-none transition-colors px-3 sm:px-4 py-2.5 sm:py-3 text-xs sm:text-sm font-poppins bg-white cursor-pointer hover:bg-gray-50">{t7}<Select.Icon className="text-gray-400"><FiChevronDown className="w-4 h-4" /></Select.Icon></Select.Trigger>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = e => setSearchQuery(e.target.value);
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  let t12;
  if ($[13] !== searchQuery) {
    t11 = <input type="text" value={searchQuery} onChange={t10} onClick={_temp} onKeyDown={_temp2} placeholder="Search indications..." className="w-full pl-9 pr-9 py-2 rounded-md border border-gray-200 focus:border-primary-primaryBlue focus:outline-none transition-colors text-sm font-poppins bg-white" />;
    t12 = searchQuery && <button type="button" onClick={e_2 => {
      e_2.stopPropagation();
      setSearchQuery("");
    }} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"><FiX className="w-4 h-4" /></button>;
    $[13] = searchQuery;
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <div className="p-2 border-b border-gray-200 sticky top-0 bg-white z-10"><div className="relative">{t9}{t11}{t12}</div></div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== filteredIndications || $[20] !== isError || $[21] !== isLoading) {
    t14 = isLoading ? <div className="px-4 py-3 text-sm text-gray-500 font-poppins text-center">Loading indications...</div> : isError ? <div className="px-4 py-3 text-sm text-red-500 font-poppins text-center">Failed to load indications</div> : filteredIndications.length > 0 ? filteredIndications.map(_temp3) : <div className="px-4 py-3 text-sm text-gray-500 font-poppins text-center">No indications found</div>;
    $[19] = filteredIndications;
    $[20] = isError;
    $[21] = isLoading;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14) {
    t15 = <Select.Viewport className="p-1 max-h-[200px] overflow-y-auto">{t14}</Select.Viewport>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t15) {
    t16 = <Select.Portal><Select.Content className="overflow-hidden bg-white rounded-lg shadow-lg border border-gray-200 z-[100000] min-w-[var(--radix-select-trigger-width)]" position="popper" sideOffset={4}>{t13}{t15}</Select.Content></Select.Portal>;
    $[25] = t13;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== isOpen || $[29] !== selectedIndication || $[30] !== t16 || $[31] !== t6) {
    t17 = <div className="mb-4 sm:mb-6">{t4}<Select.Root value={selectedIndication} open={isOpen} onOpenChange={t5} onValueChange={t6}>{t8}{t16}</Select.Root></div>;
    $[28] = isOpen;
    $[29] = selectedIndication;
    $[30] = t16;
    $[31] = t6;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="bg-blue-50 border-l-4 border-blue-500 p-3 sm:p-4 rounded-r-lg"><div className="flex items-start gap-2 sm:gap-3"><div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5"><span className="text-white text-[10px] sm:text-xs font-bold">i</span></div><p className="text-xs sm:text-sm text-gray-700 font-poppins leading-relaxed">Why we ask: Your ratings will be compared with peers treating the same indication, providing more relevant benchmarking insights.</p></div></div>;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t17) {
    t19 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t2}{t3}<div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-6">{t17}{t18}</div></div></div>;
    $[34] = t17;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== onBack) {
    t20 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[36] = onBack;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  const t21 = !selectedIndication;
  const t22 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${selectedIndication ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t23;
  if ($[38] !== onNext || $[39] !== t21 || $[40] !== t22) {
    t23 = <button disabled={t21} onClick={onNext} className={t22}>Next</button>;
    $[38] = onNext;
    $[39] = t21;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t20 || $[43] !== t23) {
    t24 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t20}{t23}</div>;
    $[42] = t20;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t19 || $[46] !== t24) {
    t25 = <>{t19}{t24}</>;
    $[45] = t19;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  return t25;
};
export default IndicationSelection;
function _temp(e_0) {
  return e_0.stopPropagation();
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}
function _temp3(indication_0) {
  return <Select.Item key={indication_0} value={indication_0} className="flex w-full cursor-pointer select-none items-center justify-between rounded-md py-2.5 px-4 text-sm font-poppins text-gray-900 outline-none hover:bg-gray-100 focus:bg-gray-100 data-[highlighted]:bg-gray-100 data-[state=checked]:bg-gray-100"><Select.ItemText>{indication_0}</Select.ItemText><Select.ItemIndicator className="flex items-center justify-center"><FiCheck className="h-4 w-4 text-primary-primaryBlue" /></Select.ItemIndicator></Select.Item>;
}